import { createStore } from 'effector';
import { Curso } from '../../models/usuario.model';
import { usuarioSelecionado } from '../usuario/usuario.store';

export const $curso = createStore<Curso | null>(null).on(usuarioSelecionado, (_, value) => value.curso);
